import Layout from '@layout/Index'

export const customerProjectcost = [
  {
    path: '/customer-projectcost',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "customer-projectcost-table" */ './pages/CustomerProjectcostTable.vue'),
        name: '项目成本列表',
        meta: {
          title: '项目成本列表',
        },
      },
      {
        path: 'table/type/:type',
        component: () => import(/* webpackChunkName: "customer-projectcost-table" */ './pages/CustomerProjectcostTable.vue'),
        meta: {
          title: '查理宝项目成本列表',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/customer-projectcost/customer-projectcost.route.js